module.exports = __webpack_public_path__ + "static/media/Slice3.11aaa6b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_170/img/Slice3.png
// module id = 1499
// module chunks = 0